class ManageReportsPageViewModel {
  tierAssignmentsVM: ko.Observable<TierAssignmentsViewModel | null> =
    ko.observable(null);
  reportManagementVM: ko.Observable<ManageReportsFormViewModel | null> =
    ko.observable(null);

  constructor() {
    this.tierAssignmentsVM(new TierAssignmentsViewModel());
  }

  handleTabClick = (tabName: string) => {
    if (tabName === "tierAssignments") {
      this.tierAssignmentsVM(new TierAssignmentsViewModel());
    } else if (tabName === "manageReports") {
      this.reportManagementVM(new ManageReportsFormViewModel());
    }
  };
}

import ManageReportsFormViewModel from "./manage-reports-form-viewmodel";
import template from "./manage-reports-page.html";
import TierAssignmentsViewModel from "./tier-assignment-viewmodel";
export default { viewModel: ManageReportsPageViewModel, template };
